import { useState } from "react";
import FormErrors from "../components/FormErrors";
import { getPasswordReset, resetPassword } from "../lib/allauth";
import { Link, Navigate, useLoaderData } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import PasswordField from "../components/PasswordField";

export async function loader ({ params }) {
  const key = params.key;
  const resp = await getPasswordReset(key);
  return { key, keyResponse: resp };
}

export default function ResetPassword () {
  const { key, keyResponse } = useLoaderData();
  const { enqueueSnackbar } = useSnackbar();

  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [password2Errors, setPassword2Errors] = useState([]);

  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit () {
    if (password2 !== password1) {
      setPassword2Errors([
        { param: "password2", message: "Password does not match." }
      ]);
      return;
    }
    setPassword2Errors([]);
    setResponse({ ...response, fetching: true });
    resetPassword({ key, password: password1 })
      .then((resp) => {
        if ([200, 401].includes(resp?.status)) {
          enqueueSnackbar(
            "Your password has been reset. Please log in with your new password.",
            { variant: "success", autoHideDuration: 8000 }
          );
        }
        setResponse((r) => {
          return { ...r, content: resp };
        });
      })
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .then(() => {
        setResponse((r) => {
          return { ...r, fetching: false };
        });
      });
  }

  if ([200, 401].includes(response.content?.status)) {
    return <Navigate to="/account/login" />;
  }
  let body;
  if (keyResponse.status !== 200) {
    body = <FormErrors param="key" errors={keyResponse.errors} />;
  } else if (response.content?.error?.detail?.key) {
    body = <FormErrors param="key" errors={response.content?.errors} />;
  } else {
    body = (
      <>
        <Box>
          <PasswordField
            fullWidth
            autoComplete="new-password"
            value={password1}
            onChange={(e) => setPassword1(e.target.value)}
            required
            label="Password"
            data-attr="reset-password_field-password"
          />
          <FormErrors param="password" errors={response.content?.errors} />
        </Box>
        <Box mt={1} mb={1}>
          <PasswordField
            fullWidth
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            required
            label="Confirm Password"
            data-attr="reset-password_field-confirm"
          />
          <FormErrors param="password2" errors={password2Errors} />
        </Box>

        <Button variant={"contained"} disabled={response.fetching} onClick={() => submit()} data-attr="reset-password_submit">
          Reset
        </Button>
      </>
    );
  }

  return (
    <Box p={1} mt={8}>
      <Typography variant="h6">Reset Password</Typography>
      <Box mt={2} mb={4}>
      {body}
      </Box>
      <Typography variant="body1">
        Remember your password? <Link to="/account/login">Back to login.</Link>
      </Typography>
    </Box>
  );
}
